/** @jsx jsx */

import { Colors, Spinner, Typography } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { useQueryServiceInfo } from 'app/developer-v3/hooks';

import ServiceIcon from './ServiceIcon';
import WistiaVideo from './WistiaVideo';

const Styles = {
  appVideoRow: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    margin: 3px 8px;
  `,
  button: css`
    background: none;
    padding: 0;
    outline: none;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-weight: 700;
    &:focus {
      outline: 2px solid;
      outline-offset: 2px;
    }
    ${Typography.Body2};
    color: ${Colors.UiPrimaryStrongest};
  `,
  root: css`
    display: inline-block;
    vertical-align: middle;
  `,
};

type Props = {
  defaultName: string;
  popoverCaption: string;
  slug: string;
  videoId: string;
};

export function WistiaAppVideo({
  defaultName,
  popoverCaption,
  slug,
  videoId,
}: Props) {
  const { images, isLoading, name = defaultName } = useQueryServiceInfo({
    slug,
  });
  return (
    <div css={Styles.root}>
      {isLoading ? (
        <Spinner />
      ) : (
        <WistiaVideo
          autoPlay={true}
          popover={true}
          popoverCaption={popoverCaption}
          wistiaID={videoId}
        >
          <div css={Styles.appVideoRow}>
            {images?.url_64x64 && (
              <ServiceIcon
                serviceName={name}
                size={30}
                src={images.url_64x64}
              />
            )}
            <button css={Styles.button}>{name}</button>
          </div>
        </WistiaVideo>
      )}
    </div>
  );
}
